import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  FETCH_MENU_CURATION_TASKS,
  UPDATE_MENU_CURATION_TASK_NON_URL_FILTERS,
  UPDATE_MENU_CURATION_TASK_PERSISTED_FILTERS,
} from '../action-types'

export const cleanupFetchMenuCurationTasks = createAction(
  FETCH_MENU_CURATION_TASKS.CLEANUP,
)

export const updateMenuCurationTasksPersistedFilters = createPayloadAction(
  UPDATE_MENU_CURATION_TASK_PERSISTED_FILTERS,
)

export const updateMenuCurationTasksNonUrlFilters = createPayloadAction(
  UPDATE_MENU_CURATION_TASK_NON_URL_FILTERS,
)
